import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ButtonToolbar from '../../components/ButtonToolbar';

@connect((state, props) => {
		return {
			form: state.forms.get('newproblem')
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class ProblemForm extends Component {

	constructor(props, context) {
		super(props, context);

		this.schema = {
			rating: {
				class: Select,
				options: DbInfo.Rating,
				value: 1,
				clearable: false,
				label: 'Úroveň'
			},
			title: {
				class: TextInput,
				label: 'Text',
				autoFocus: true,
				style: {width: '100%'},
				rules: {
					 presence: {message: 'Text je povinná položka!'}
				}
			}
		};
		this.form = new FormManager(this.schema);
	}

	save() {
		const values = this.form.getValues().toJS();
		this.props.onSave(values);
	}

	render() {

		const saveCloseButton = <LoadingButton
			title="Uložit"
			onClick={()=>this.save()}
		/>;

		return (
			<div style={{position:'relative'}}>
				<RxForm ref="form" form={this.form} id={'newproblem'} disableInitRedux={true}>
					<div className="row">
						<div>
							<table className="form">
								<tbody>
								{Object.keys(this.schema).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={70}/>
								})}
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Checkpoint/ProblemForm.js